import * as React from 'react'
import type { SVGProps } from 'react'
const SvgFile = (props: SVGProps<SVGSVGElement>) => {
  return (

    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.5306 7.71938L15.2806 2.46938C15.2109 2.39975 15.1282 2.34454 15.0371 2.3069C14.9461 2.26926 14.8485 2.24992 14.75 2.25H5.75C5.35218 2.25 4.97064 2.40804 4.68934 2.68934C4.40804 2.97064 4.25 3.35218 4.25 3.75V20.25C4.25 20.6478 4.40804 21.0294 4.68934 21.3107C4.97064 21.592 5.35218 21.75 5.75 21.75H19.25C19.6478 21.75 20.0294 21.592 20.3107 21.3107C20.592 21.0294 20.75 20.6478 20.75 20.25V8.25C20.7501 8.15148 20.7307 8.05391 20.6931 7.96286C20.6555 7.87182 20.6003 7.78908 20.5306 7.71938ZM15.5 4.81031L18.1897 7.5H15.5V4.81031ZM19.25 20.25H5.75V3.75H14V8.25C14 8.44891 14.079 8.63968 14.2197 8.78033C14.3603 8.92098 14.5511 9 14.75 9H19.25V20.25Z" fill="#002A73"/>
    </svg>
    
    
    

  )
}

export default SvgFile